define([
	"csi/def",
	"csi/def/ActionFactory",
	"csi/widget/MessageDialog",
	"./ActionImage"
], function(def,ActionFactory,MessageDialog,ActionImage) {

	return ActionFactory.declare("imageRemove", ActionImage, {
		bAllowImageRef: true,
		confirmAction: MessageDialog.BUTTON_REMOVE,
		confirmIcon: MessageDialog.ICON_QUESTION,
		
		constructor: function(xml) {
			this.m_id = "PropertyImageRemove";
			this.m_class = "iconImageRemove";
			this.m_typeControl = def.ACTION_ICON;
		},

		hasAccess: function(/*def.Context*/ctx) {
			// summary: determine if selected image can be removed
			var	key = ctx.view.getCurrentImageKey();
			return key && this.inherited(arguments);
		}
	});
});